import React, { PropTypes } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import naturalSortBy from '@bibliocommons/natural-sort-by';
import { Table } from '@bibliocommons/base-table';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import { Location, Arrows } from '@bibliocommons/base-icons';
import { TextButton } from '@bibliocommons/base-buttons';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';
import injectLibrary from '../../../containers/hocs/injectLibrary';

import './AvailabilityTable.scss';

export class AvailabilityTable extends BcReactComponent {
  constructor(props) {
    super(props);
    this.bindAll('renderStatus');
  }

  static handleAlphanumericSort(items, sortField, sortDirection) {
    return items.sort(naturalSortBy(sortField, sortDirection));
  }

  shouldRenderStackMap(item) {
    const { stackMap } = this.props;

    return stackMap.get('enabled') &&
      item.get('collection') &&
      item.get('callNumber') &&
      stackMap.get('supportedBranches').includes(item.getIn(['branch', 'name'])) &&
      item.getIn(['availability', 'status']) !== 'UNAVAILABLE';
  }

  renderStatus(value, index) {
    const item = this.props.rows.get(index);
    const stackMap = this.props.stackMap;
    const renderStackMapLink = this.shouldRenderStackMap(item);

    if (renderStackMapLink) {
      return (
        <span>
          {value}
          <TextButton handleClick={() => this.props.openStackMap(stackMap, item)} className="stackmap-link">
            <Location />

            <FormattedMessage id="map_it">
              {(message) => <span aria-hidden>{message}</span>}
            </FormattedMessage>

            <ScreenReaderMessage>
              <FormattedMessage id="ada_map_it" values={{ branch: item.getIn(['branch', 'name']) }} />
            </ScreenReaderMessage>

            <Arrows.long.Right color="currentColor" />
          </TextButton>
        </span>
      );
    }

    return value;
  }

  render() {
    const { intl, rows, status, singleBranch, showDueDateInCirc, showCollectionInCirc } = this.props;
    const count = rows.size;
    const inSiteScope = rows.first().get('inSiteScope');
    let fields = [
      { key: 'callNumber', type: 'String', sort: AvailabilityTable.handleAlphanumericSort },
      { key: 'volume', type: 'String', sort: AvailabilityTable.handleAlphanumericSort },
      { key: 'copy', type: 'String', sort: AvailabilityTable.handleAlphanumericSort },
      { key: 'availability.libraryStatus', type: 'String', sort: AvailabilityTable.handleAlphanumericSort, transformationMap: this.renderStatus }
    ];

    if (showCollectionInCirc) {
      fields = [{ key: 'collection', type: 'String', sort: AvailabilityTable.handleAlphanumericSort }, ...fields];
    }

    if (showDueDateInCirc) {
      fields = [...fields, { key: 'dueDate', type: 'Date', sort: AvailabilityTable.handleAlphanumericSort }];
    }

    if (!singleBranch) {
      fields = [
        { key: 'branchName', type: 'String', sort: AvailabilityTable.handleAlphanumericSort },
        ...fields
      ];
    }

    return (
      <div className="cp-availability-table">
        <FormattedMessage
          id="CircTableTitle"
          values={{
            status: intl.formatMessage({ id: `circ_table_${status.toLowerCase()}` }),
            count,
            inSiteScope: inSiteScope ? 'yes' : 'no'
          }}>
          {string => (
            <h4 className={status.toLowerCase()}>{string}</h4>
            )}
        </FormattedMessage>
        <Table
          rows={rows}
          fields={fields}
          sortable />
      </div>
    );
  }
}

AvailabilityTable.propTypes = {
  rows: ImmutablePropTypes.list.isRequired,
  status: PropTypes.string.isRequired,
  singleBranch: PropTypes.bool.isRequired,
  intl: intlShape,
  stackMap: ImmutablePropTypes.mapContains({
    enabled: PropTypes.bool,
    branches: ImmutablePropTypes.listOf(PropTypes.string),
    domain: PropTypes.string
  }),
  openStackMap: PropTypes.func.isRequired,
  showDueDateInCirc: PropTypes.bool,
  showCollectionInCirc: PropTypes.bool
};

AvailabilityTable.displayName = 'AvailabilityTable';

const mapLibraryToProps = ({ library }) => ({ singleBranch: library.get('singleBranch') });

export default injectIntl(injectLibrary(mapLibraryToProps)(AvailabilityTable));



// WEBPACK FOOTER //
// ./app/components/shared/AvailabilityTable/AvailabilityTable.jsx